import React from "react";
import PropTypes from "prop-types";
import { Navbar, NavbarBrand } from "../../../components/ui";

import { Dispatcher, Constants } from "../../../flux";

class SidebarMainNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.handleToggleSidebar = this.handleToggleSidebar.bind(this);
  }

  handleToggleSidebar() {
    Dispatcher.dispatch({
      actionType: Constants.TOGGLE_SIDEBAR
    });
  }

  render() {
    const { hideLogoText } = this.props;
    let user = localStorage.getItem("user");
    return (
      <div className="main-navbar mobile-sidebar-header">
        <Navbar className="mobile-sidebar-header__bar align-items-center flex-md-nowrap border-bottom p-0">
          <span className="mobile-sidebar-header__spacer" aria-hidden="true" />
          <NavbarBrand
            className="mobile-sidebar-header__brand mr-0"
            href={user ? "/blogs/premium/" : "/"}
          >
            <img
              id="main-logo"
              className="mobile-sidebar-header__logo"
              src={require("../../../images/bitcoin-live/logo.png")}
              alt="Bitcoin Live"
            />
            {!hideLogoText && (
              <span className="d-none d-md-inline ml-1">
                <span>BITCOIN</span>{" "}
                <span style={{ color: "#FAA61A" }}>LIVE</span>
              </span>
            )}
          </NavbarBrand>
          {/* eslint-disable-next-line */}
          <a
            className="toggle-sidebar mobile-sidebar__close d-sm-inline d-md-none d-lg-none"
            onClick={this.handleToggleSidebar}
            aria-label="Close menu"
          >
            <i className="material-icons">arrow_back</i>
          </a>
        </Navbar>
      </div>
    );
  }
}

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false
};

export default SidebarMainNavbar;
